import { IResTimeSlot } from 'api/services/timeslots-branches/types';
import { useSelector } from 'react-redux';
import { useParams } from 'react-router';
import { AppState } from 'store/store';
import './TimeSlots.sass';

interface Props {
  slots: IResTimeSlot[];
  onClick: (val: IResTimeSlot) => void;
}

const TimeSlots: React.FC<Props> = ({ slots, onClick }) => {
  const i18n = useSelector(
    (state: AppState) => state.i18n.data.components.TimeSlots,
  );
  const { scheduleId } = useParams<{ scheduleId: string }>();
  const { lang } = useSelector((state: AppState) => state.i18n) as any;

  const isPassed = (slotTime: string) => {
    if (!scheduleId) return;
    const now = new Date();
    const [year, month, day] = scheduleId.split('-').map(Number);
    const [hours, minutes] = slotTime.split(':').map(Number);

    const slotDate = new Date(year, month - 1, day, hours, minutes, 0, 0);

    return now > slotDate;
  };

  return (
    <div className='time-slots'>
      <div className='time-slots__row'>
        {slots?.map((slot) => {
          const isFull = slot.reserved >= slot.theoryCapacity;
          const availableCount = slot.theoryCapacity - slot.reserved;

          return (
            <button
              key={slot.id}
              disabled={isFull}
              onClick={() => onClick(slot)}
              className={`time-slots__item ${isFull ? 'time-slots__item--full' : ''} ${isPassed(slot.fromTime) ? 'time-slots__item--disabled' : ''}`}
            >
              <div className='time-slots__time'>
                {slot.fromTime} — {slot.toTime}
              </div>

              <div className='time-slots__info'>
                {isFull ? (
                  <span className='time-slots__status-label time-slots__status-label--full'>
                    {i18n.noPlaces}
                  </span>
                ) : (
                  <span className='time-slots__status-label time-slots__status-label--available'>
                    {lang === 'uz' || lang === 'oz' ? (
                      <>
                        {slot.theoryCapacity} {i18n.of} {availableCount}{' '}
                        {i18n.available}
                      </>
                    ) : (
                      <>
                        {i18n.available} {availableCount} {i18n.of}{' '}
                        {slot.theoryCapacity}
                      </>
                    )}
                  </span>
                )}
              </div>

              {!isFull && (
                <div className='time-slots__action'>{i18n.choose}</div>
              )}
            </button>
          );
        })}
      </div>
    </div>
  );
};

export default TimeSlots;
